(() => {
  'use strict';

  const isArabic = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');

  const normalizePath = (href) => {
    try {
      return new URL(href, window.location.origin).pathname
        .replace(/^\/(ar|en)(?=\/|$)/i, '')
        .replace(/\/$/, '') || '/';
    } catch (_) {
      return '';
    }
  };

  const applyDescriptionAccordionFix = () => {
    if (!document.body.classList.contains('template-product')) return;

    const detailsRoot = document.querySelector('.rp__details--gallery');
    if (!detailsRoot) return;

    const descriptionDetails = Array.from(detailsRoot.querySelectorAll('details')).find((item) => {
      const summary = item.querySelector('summary');
      const label = (summary?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

      return label.includes('ماذا يفعل') ||
        label.includes('what does it do') ||
        label.includes('what it does') ||
        label === 'الوصف' ||
        label === 'description';
    });

    if (!descriptionDetails) return;

    const summary = descriptionDetails.querySelector('summary');
    if (summary) {
      const indicator = summary.querySelector('span') || document.createElement('span');
      summary.textContent = isArabic() ? 'الوصف' : 'Description';
      summary.appendChild(indicator);
    }

    descriptionDetails.open = true;
  };

  const ensureBlogNavigation = () => {
    const localeMatch = window.location.pathname.match(/^\/(ar|en)(?=\/|$)/i);
    const localePrefix = localeMatch ? localeMatch[0] : '';
    const blogPath = '/blogs/beauty-journal';
    const blogHref = `${localePrefix}${blogPath}`;
    const label = isArabic() ? 'المدونة' : 'Blog';
    const currentPath = normalizePath(window.location.href);
    const isCurrent = currentPath === blogPath || currentPath.startsWith(`${blogPath}/`);

    const setCurrent = (link) => {
      if (isCurrent) link.setAttribute('aria-current', 'page');
    };

    const desktopNav = document.querySelector('.rh__nav-inner');
    if (desktopNav && !Array.from(desktopNav.querySelectorAll('a[href]')).some((link) => normalizePath(link.href) === blogPath)) {
      const item = document.createElement('div');
      item.className = 'rh__nav-item rb-nav-blog';

      const link = document.createElement('a');
      link.className = 'rh__nav-link';
      link.href = blogHref;
      link.textContent = label;
      setCurrent(link);

      item.appendChild(link);
      desktopNav.appendChild(item);
    }

    const mobileNav = document.querySelector('.rh-mobile nav');
    if (mobileNav && !Array.from(mobileNav.querySelectorAll('a[href]')).some((link) => normalizePath(link.href) === blogPath)) {
      const link = document.createElement('a');
      link.className = 'rh-mobile__direct-link rb-nav-blog';
      link.href = blogHref;
      link.textContent = label;
      setCurrent(link);
      mobileNav.appendChild(link);
    }

    const footer = document.querySelector('.r-footer, footer');
    if (!footer) return;

    const oldBeautyTipsLink = Array.from(footer.querySelectorAll('a[href]')).find((link) => normalizePath(link.href) === '/pages/beauty-tips');
    if (oldBeautyTipsLink) {
      oldBeautyTipsLink.href = blogHref;
      oldBeautyTipsLink.textContent = label;
      setCurrent(oldBeautyTipsLink);
      return;
    }

    const existingFooterLink = Array.from(footer.querySelectorAll('a[href]')).find((link) => normalizePath(link.href) === blogPath);
    if (existingFooterLink) {
      setCurrent(existingFooterLink);
      return;
    }

    const groups = Array.from(footer.querySelectorAll('.r-footer__link-group'));
    const target = groups.find((group) => /تهمك|useful|links/i.test(group.querySelector('h3')?.textContent || '')) || groups[0];
    if (!target) return;

    const link = document.createElement('a');
    link.href = blogHref;
    link.textContent = label;
    setCurrent(link);
    target.appendChild(link);
  };

  const run = () => {
    applyDescriptionAccordionFix();
    ensureBlogNavigation();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
